/* Sprint 9.3 — Impostazioni studio (profilo + branding + role) */

.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 920px;
  margin: 0 auto;
}

.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  overflow: hidden;
}

.cardHeader {
  padding: 18px 22px 12px;
  border-bottom: 1px solid var(--line-3);
}

.cardTitle {
  margin: 0;
  font-family: var(--display);
  font-weight: 800;
  font-size: 17px;
  letter-spacing: -0.4px;
  color: var(--ink);
}

.cardSub {
  margin: 4px 0 0;
  font-family: var(--sans);
  font-size: 12.5px;
  color: var(--mute);
  line-height: 1.45;
}

.cardBody {
  padding: 20px 22px 22px;
}

.row {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 18px;
  align-items: flex-start;
  padding: 14px 0;
  border-top: 1px solid var(--line-3);
}

.row:first-child {
  border-top: 0;
  padding-top: 0;
}

.rowLabel {
  font-family: var(--sans);
  font-weight: 600;
  font-size: 13px;
  color: var(--ink-3);
  padding-top: 8px;
}

.rowLabelMain {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 13.5px;
  color: var(--ink);
  margin-bottom: 2px;
}

.rowLabelHint {
  font-family: var(--sans);
  font-size: 11.5px;
  color: var(--mute);
  font-weight: 500;
  line-height: 1.45;
}

.rowControl {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.input,
.textarea {
  font-family: var(--sans);
  font-size: 14px;
  padding: 9px 12px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--ink);
  width: 100%;
}

.input:focus,
.textarea:focus {
  outline: none;
  border-color: var(--role-accent);
}

.input:disabled,
.textarea:disabled {
  background: var(--surface-2);
  cursor: not-allowed;
  color: var(--mute);
}

.textarea {
  min-height: 96px;
  resize: vertical;
  font-family: var(--sans);
  line-height: 1.5;
}

.inputReadonly {
  background: var(--surface-2);
  color: var(--mute);
  cursor: not-allowed;
}

.inputHint {
  font-size: 11.5px;
  color: var(--mute);
}

.inputCount {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--mute);
  text-align: right;
}

/* Radio group pro_kind */
.radioGroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.radioCard {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  cursor: pointer;
  background: var(--surface);
  transition: border-color .12s, background .12s;
}

.radioCard:hover {
  background: var(--surface-2);
}

.radioCardActive {
  border-color: var(--role-accent);
  background: var(--role-accent-tint);
}

.radioCardActive:hover {
  background: var(--role-accent-tint);
}

.radioInput {
  margin: 4px 0 0;
  accent-color: var(--role-accent);
  cursor: pointer;
}

.radioBody {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.radioTitle {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 13.5px;
  color: var(--ink);
}

.radioDesc {
  font-family: var(--sans);
  font-size: 12px;
  color: var(--mute);
  line-height: 1.4;
}

/* Color row */
.colorRow {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.brandPreview {
  margin-top: 18px;
  padding: 16px 18px;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--surface);
}

.brandPreviewLbl {
  font-family: var(--mono);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--mute);
}

.brandPreviewBody {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.brandPreviewLogo {
  width: 48px;
  height: 48px;
  border-radius: var(--r-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--display);
  font-weight: 800;
  font-size: 16px;
  color: #fff;
  flex-shrink: 0;
  overflow: hidden;
  background: var(--ink);
}

.brandPreviewLogo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.brandPreviewName {
  font-family: var(--display);
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.4px;
  color: var(--ink);
}

.brandPreviewSwatches {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}

.brandPreviewSwatch {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid var(--line);
}

/* Buttons */
.actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 18px;
  border-top: 1px solid var(--line-3);
  margin-top: 18px;
}

.actionsCompact {
  margin-top: 12px;
  padding-top: 12px;
}

.btnPrimary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  font-family: var(--sans);
  font-size: 13.5px;
  font-weight: 700;
  border-radius: var(--r-sm);
  border: 1px solid var(--role-accent-deep);
  background: var(--role-accent);
  color: #fff;
  cursor: pointer;
  transition: background .12s;
}

.btnPrimary:hover:not(:disabled) {
  background: var(--role-accent-deep);
}

.btnPrimary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btnGhost {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  font-family: var(--sans);
  font-size: 13px;
  font-weight: 600;
  border-radius: var(--r-sm);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink-2);
  cursor: pointer;
}

.btnGhost:hover:not(:disabled) {
  background: var(--surface-2);
}

.btnGhost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Toast */
.toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  padding: 12px 18px;
  border-radius: var(--r-md);
  font-family: var(--sans);
  font-size: 13.5px;
  font-weight: 600;
  box-shadow: var(--shadow-md);
  background: var(--ink);
  color: #fff;
  max-width: 360px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.toastError {
  background: var(--red);
}

.toastSuccess {
  background: var(--green-deep);
}

/* Warning callout */
.warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: var(--r-sm);
  background: var(--orange-soft);
  border: 1px solid #f5c89a;
  color: var(--ink);
  font-family: var(--sans);
  font-size: 12.5px;
  line-height: 1.5;
  margin-top: 12px;
}

.warningIcon {
  flex-shrink: 0;
  color: var(--orange-deep);
  margin-top: 1px;
}

/* Codice invito */
.codeBlock {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.codeValue {
  font-family: var(--mono);
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 6px;
  color: var(--ink);
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  padding: 14px 18px;
  text-align: center;
  user-select: all;
}

.codeNote {
  font-size: 12px;
  color: var(--mute);
}

.codeRow {
  display: flex;
  gap: 8px;
  align-items: center;
}

.codeLink {
  font-family: var(--mono);
  font-size: 12px;
  padding: 9px 12px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  color: var(--ink-2);
  flex: 1;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Subscription block */
.subRow {
  display: flex;
  align-items: center;
  gap: 14px;
  font-family: var(--sans);
  font-size: 13.5px;
}

.subBadge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  background: var(--green-soft);
  color: var(--green-deep);
}

.subBadgePast {
  background: #fbe5e5;
  color: var(--red);
}

.subBadgeNeutral {
  background: var(--surface-2);
  color: var(--mute);
}

.skeleton {
  padding: 48px 24px;
  text-align: center;
  color: var(--mute);
  font-family: var(--sans);
  font-size: 13px;
}

.errorBox {
  padding: 16px 18px;
  border-radius: var(--r-md);
  border: 1px solid #f4b8b8;
  background: #fbe5e5;
  color: var(--red);
  font-family: var(--sans);
  font-size: 13.5px;
}

@media (max-width: 760px) {
  .row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .rowLabel {
    padding-top: 0;
  }
  .actions {
    flex-direction: column-reverse;
    align-items: stretch;
  }
}

/* Sprint 8.4 — Cal.com section */
.calcomStateRow {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  background: var(--surface-2);
}

.calcomStateRowConnected {
  background: var(--green-soft);
  border-color: #b9e4c2;
}

.calcomStateRowPending {
  background: var(--orange-soft);
  border-color: #f5c89a;
}

.calcomStateRowError {
  background: #fbe5e5;
  border-color: #f4b8b8;
}

.calcomStateTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--sans);
  font-weight: 700;
  font-size: 13.5px;
  color: var(--ink);
}

.calcomStateLabel {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-family: var(--mono);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  background: var(--green-deep);
  color: #fff;
}

.calcomStateLabelPending {
  background: var(--orange-deep);
  color: #fff;
}

.calcomStateLabelError {
  background: var(--red);
  color: #fff;
}

.calcomMeta {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-family: var(--sans);
  font-size: 12.5px;
  color: var(--ink-2);
}

.calcomMetaItem strong {
  color: var(--ink);
  font-weight: 700;
}

.calcomActions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btnDanger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  font-family: var(--sans);
  font-size: 13px;
  font-weight: 600;
  border-radius: var(--r-sm);
  border: 1px solid #d59999;
  background: #fbe5e5;
  color: var(--red);
  cursor: pointer;
}

.btnDanger:hover:not(:disabled) {
  background: #f9d4d4;
}

.calcomSyncStats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px dashed var(--line);
  border-radius: var(--r-sm);
  background: var(--surface);
  font-family: var(--mono);
  font-size: 11.5px;
  color: var(--ink-2);
}

.calcomSyncStats span strong {
  color: var(--ink);
}

.calcomConflictList {
  margin-top: 8px;
  padding: 8px 12px;
  background: #fff7e6;
  border: 1px solid #f5c89a;
  border-radius: var(--r-sm);
  font-family: var(--sans);
  font-size: 12px;
  color: var(--ink);
}

.calcomConflictList ul {
  margin: 6px 0 0 16px;
  padding: 0;
}

/* Sprint 10 Fase 3/F5 — Consumo del piano (usage badge) */
.usageBlock {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.usageItem {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.usageItemHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  font-family: var(--sans);
}

.usageItemLabel {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--ink-2);
}

.usageItemValue {
  font-family: var(--mono);
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
}

.usageItemValueWarn {
  color: var(--orange-deep);
}

.usageItemValueDanger {
  color: var(--red);
}

.usageBar {
  height: 8px;
  border-radius: 999px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  overflow: hidden;
}

.usageBarFill {
  height: 100%;
  border-radius: 999px;
  background: var(--green-deep);
  transition: width .2s ease;
}

.usageBarFillWarn {
  background: var(--orange-deep);
}

.usageBarFillDanger {
  background: var(--red);
}
